export interface Team {
    athlete1: string,
    athlete2: string,
}

export interface AmrapResult {
    reps: number,
}

export interface TimeCapResult {
    mins?: number,
    seconds?: number,
    reps?: number,
    cap?: boolean
}

export interface WeightResult {
    weight: number,
}

// The higher the time the better
export interface MaxTimeResult {
    mins: number,
    seconds: number,
}

export type WodResult = AmrapResult | TimeCapResult | WeightResult | MaxTimeResult;

export interface TeamWodResult {
    team: Team,
    result: WodResult,
    points: number,
    ranking: number
}

export interface Wod {
    results: TeamWodResult[],
    name: string,
    category: WodCat,
    type: WodType
}

export interface TeamRanking {
    team: Team,
    overview: TeamRankingOverview[],
    points: number,
    ranking: number
}

export interface TeamRankingOverview {
    position: number,
    points: number
}

export interface Ranking {
    name: string,
    category: WodCat,
    result: TeamRanking[]
}

export enum WodType {
    AMRAP,
    TIMECAP,
    WEIGHT,
    MAXTIME
}

export enum WodCat {
    SCALE,
    RX
}

export interface WodDescription {
    title: string,
    category: WodCat,
    subtitle: string,
    items: string[],
    footer: string
}

export interface Heat {
    teams: Team[],
    number: number,
    name: string,
    category: WodCat,
    differentCategoryIndex?: number[]
}

export type ScreenData = Wod | WodDescription | Heat | Ranking

export interface ScreenType {
    data: ScreenData,
    visible: boolean
}